
export default function headerSearch() {

    const searchWrap = document.querySelector('.header__search-wrap');


    if ( searchWrap ) {
        searchWrap.addEventListener('click',function(){
            searchWrap.classList.add("header__search-wrap_show");
        });
    }

    

}